(function(){
     'use strict';

     angular
        .module('app')
        .factory('FieldsService', FieldsService);

    FieldsService.$inject = ['$http'];

    function FieldsService($http){


        var service= {
            getConfigfield: getConfigfield,
            getFieldsByNode:getFieldsByNode
        };

        return service;

        function getConfigfield(type,id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                id:id,
                type: type
            });
            $http.post('/backend/altcrm/nodefields/configfield', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getFieldsByNode(type,filter,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                type: type,
                filter: filter
            });
            $http.post('/backend/altcrm/nodefields/getfieldsbynode', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
    }
})();